import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import qs from 'qs';

async function fetchClosedTrancheDeployments({ queryKey }) {
  const [, firmId] = queryKey;
  const queryParams = qs.stringify({
    firmId,
  });

  const url = firmId
    ? `dashboard/closed-tranche-deployments?${queryParams}`
    : `dashboard/closed-tranche-deployments`;

  const { data } = await api.get(url);

  return data.data;
}

export function useClosedTrancheDeployments({ firmId }) {
  return useQuery({
    queryKey: ['closed-tranche-deployments', firmId],
    queryFn: fetchClosedTrancheDeployments,
    placeholderData: keepPreviousData,
    staleTime: 4 * 60 * 60 * 1000,
  });
}

export default useClosedTrancheDeployments;
